export default {
    props: {
        item: Object
    },
    template: `
      <div :class="['date', item.choosen ? 'choosen' : '' ]" @click.prevent="chooseDay">
            <div class="date__weekday">{{splitDate(item.weekday)}}</div>
            <p>{{splitDate(item.month)}}, {{item.day}}</p>
      </div>`,
    data() {
        return {}
    },
    computed: {},
    mounted() {
    },
    methods: {
        splitDate(date) {
            return date.substring(0, 3);
        },
        chooseDay() {
            this.$emit('click', this.item);
        }
    },
    watch: {}
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/components/dateComponent.js